__turbopack_context__.v({
  "deliverySlotWrapper": "io83Ea_deliverySlotWrapper",
  "noDelivery": "io83Ea_noDelivery",
  "title": "io83Ea_title",
  "wrapper": "io83Ea_wrapper",
});
